import React, { useEffect, useState } from 'react'
import {Box, Grid, GridItem,IconButton, Heading, Tab, TabList, TabPanel, TabPanels, Tabs,Flex,Text, Input, Spacer} from '@chakra-ui/react'
import NavBar from '../../../elements/NavBar'
import CurrentCollection from './components/CurrentCollection'
import ApprovedBorrowers from './components/Upcoming_Collection.js'
import PendingBorrowers from './components/Missing_Collection.js'
import {useHistory} from 'react-router-dom'
import * as routesNames from '../../../../constants/routes'
import { removeAll, removeItem, setItem } from '../../../../utilities/authUtils'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Collection_Loan_Details from './components/Collection_Loan_Details.js.js'
import Upcoming_Collection from './components/Upcoming_Collection.js'
import Missing_Collection from './components/Missing_Collection.js'
import Closed_Collection from './components/Closed_Collection.js'
import ClosedLoan from './components/ClosedLoan.js'
import CustomButton from '../../../elements/customButton'
import { bindActionCreators } from "redux";
import { ActionCreators } from "../../../../redux/actions";
import { connect } from "react-redux";


const tabNames = [
    {
        id: 1,
        name: 'Current',
    },
    {
        id: 2,
        name: 'Upcoming',
    },
    {
        id: 3,
        name: 'Missed',
    },
    {
        id: 4,
        name: 'Paid',
    },
    {
        id: 5,
        name: 'Closed Loan',
    },
]

function Collections(props) {
    const history = useHistory()
    const adminState = useSelector((state) => state.adminState)
    const filterData = adminState?.getCurrentCollection?.data?.filterData || [];
    const [selectedTab, setSelectedTab] = useState(tabNames[0].name)
    const [inputValues, setInputValues] = useState({})
    const userData = adminState?.getUserByToken?.data?.data
    const userType = userData?.usertype
    const[selectedItem,setSelectedItem] =useState(null)

    useEffect(() => {
        props.actions.getUserByTokenAction()
    }, [])

    const handleTabChange = (index) => {
        
        setSelectedTab(tabNames[index].name);
    }
    const handleVerify = (item) => {
       setItem('loan_ID', item?.loan_id)
        setItem("boRRower_ID",item?.borrower_id )
        setItem("loandetails_type", 2 )
        if((selectedTab === 'Current' || selectedTab === 'Upcoming' || selectedTab === 'Missed' || selectedTab === 'Paid' || selectedTab === 'Closed Loan' )) {
            history.push({pathname: routesNames.ADMINUSERCOLLECTION_LOAN_DETAILS, state: item})
        }
    }

   const handleChange = (e) => {
        const { name, value } = e.target;
        setInputValues({...inputValues, [name]: value})
    }

    const getPreviousMonthDate = () => {
        const today = new Date();
        const previousMonth = new Date(today.setMonth(today.getMonth() - 2));
        return previousMonth.toISOString().split('T')[0]; 
    };

    const getFutureDateMonthDate = () => {
        const today = new Date();
        const previousMonth = new Date(today.setMonth(today.getMonth() + 2));
        return previousMonth.toISOString().split('T')[0]; 
    };
    

  return (
    <Box className='dashboard_box bg_shadow'>
        <Grid className="main_grid_container align-items-center">
            <GridItem colSpan={8}>
                <Heading as="h2" className='font-poppins page_heading'> Collection Data</Heading>
            </GridItem>
            <GridItem colSpan={4}>
                <NavBar data={userData} isAdmin />
            </GridItem>
        </Grid>
        <Flex mt={5} alignItems='end' justifyContent='end' gap={2} className='custom_select'>
            <Flex alignItems='center' gap={2}>
                <Box className='select_report_type'>
                    <Text className="font-poppins">From Date</Text>
                    <Input size="md" name="from_date" type="date" placeholder="DD/MM/YYYY" className="select_report font-poppins"
                        onChange={handleChange} value={inputValues?.from_date  ||  getPreviousMonthDate()}
                    />
                </Box>
                <Box className='select_report_type'>
                    <Text className="font-poppins">To Date</Text>
                    <Input size="md" name="to_date" type="date" placeholder="DD/MM/YYYY" className="select_report font-poppins"
                        onChange={handleChange} value={inputValues?.to_date || getFutureDateMonthDate()}
                    />
                </Box>
            </Flex>
            {/* <CustomButton size="md" type="submit" title="Generate Report" className="font-poppins btn_theme" onClick={handleGenerateReport} /> */}
        </Flex>
        <Box mt={5}>
            <Tabs className='tabs_container' onChange={handleTabChange}>
                <TabList className='tabs_list'>
                    {tabNames?.map((item, index) => {
                        return (
                            <Tab key={index}>{item.name}</Tab>
                        )
                    })}
                </TabList>
                <TabPanels>
                    {tabNames.map((item, index) => {
                        return (
                            <TabPanel key={index} className='tab_panel'>
                                {item.name === 'Current' &&
                                    <CurrentCollection
                                        tabSelected={selectedTab}
                                        handleVerify={handleVerify}
                                        inputValues={inputValues}
                                        handleChange={handleChange}
                                        userType={userType}
                                        // filterData={filterData} 
                                    />
                                }
                                {item.name === 'Upcoming' &&
                                    <Upcoming_Collection
                                        tabSelected={selectedTab}
                                        inputValues={inputValues}
                                        handleChange={handleChange}
                                        handleVerify={handleVerify}
                                    />
                                }
                                {item.name === 'Missed' &&
                                    <Missing_Collection
                                        tabSelected={selectedTab}
                                        inputValues={inputValues}
                                        handleChange={handleChange}
                                        handleVerify={handleVerify}
                                    />
                                }
                                {item.name === 'Paid' &&
                                    <Closed_Collection
                                        tabSelected={selectedTab}
                                        inputValues={inputValues}
                                        handleChange={handleChange}
                                        handleVerify={handleVerify}
                                    />
                                }
                                {item.name === 'Closed Loan' &&
                                    <ClosedLoan
                                        tabSelected={selectedTab}
                                        inputValues={inputValues}
                                        handleChange={handleChange}
                                        handleVerify={handleVerify}
                                    />
                                }
                            </TabPanel>
                        )
                    })}
                </TabPanels>
            </Tabs>
        </Box>

            {/* Render Collection_Loan_Details if selectedItem is not null */}
            {selectedItem && <Collection_Loan_Details filterData={selectedItem} />}
    </Box>
  )
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(ActionCreators, dispatch),
  });
  
  export default connect(null, mapDispatchToProps)(Collections);
  